import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  SimpleChange,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ScriptLoaderService } from "../_services/script-loader.service";
import { AuthenticationService } from "./_services/authentication.service";
import { AlertService } from "./_services/alert.service";
import { AlertComponent } from "./_directives/alert.component";
import { LoginCustom } from "./_helpers/login-custom";
import { Helpers } from "../helpers";
import { environment } from "../../environments/environment";
import { UserService } from "./_services/user.service";
import { CookieService } from "ngx-cookie-service";
import { appService } from "../_services/app.service";
import { CommonService } from '../_services/common.service';
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
import { EncryptPipe, DecryptPipe } from './_services/encrypt-decrypt.pipe';
const LNG_KEY = "SELECTED_LANGUAGE";

declare var jquery: any;
declare var $: any;
@Component({
  selector: ".m-grid.m-grid--hor.m-grid--root.m-page",
  templateUrl: "./templates/login.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class AuthComponent implements OnInit {
  selectedLang: string;

  model: any = {};
  loading = false;
  returnUrl: string;
  Setcookielist: any = {};
  EmailId: any;
  flag: any;
  @ViewChild("alertSignin", { read: ViewContainerRef })
  alertSignin: ViewContainerRef;
  @ViewChild("alertSignup", { read: ViewContainerRef })
  alertSignup: ViewContainerRef;
  @ViewChild("alertForgotPass", { read: ViewContainerRef })
  alertForgotPass: ViewContainerRef;
  toastr: any;
  form: any = 'si';
  hostUrl: any = environment.apiUrl;
  WhiteLabel: any;

  //add vithujan 30-08-2022
  ForgotPassword: any = [];
  interval;
  timeLeft: number = 0;
  display;
  isShowTimer: boolean = false;
  //end
  isBestUrl: any = environment.apiUrl == 'https://best.ifreightbox.net/' ? true : false;

  constructor(
    private _router: Router,
    private _script: ScriptLoaderService,
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _authService: AuthenticationService,
    private _alertService: AlertService,
    private cfr: ComponentFactoryResolver,
    private cookieService: CookieService,
    private _appService: appService,
    private _commonService: CommonService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private http: HttpClient,
    private encryptpipe: EncryptPipe,
    private decryptpipe: DecryptPipe
  ) {
    if (this.hostUrl == 'https://nol.ifreightbox.net/') {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
    else {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  onClickFp(value) {
    this.form = value;
  }
  ngOnInit() {
    this.model.remember = true;
    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";
    this._router.navigate([this.returnUrl]);
    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js",
        ],
        true
      )
      .then(() => {
        Helpers.setLoading(false);
        LoginCustom.init();
        this.getWhiteLable();
        // setTimeout(() => {
        //   this.getWhiteLable();
        // }, 1000);
      });
  }

  testsms() {
    var settings = {
      url: "https://mpmdpj.api.infobip.com/sms/advanced",
      method: "POST",
      timeout: 0,
      headers: {
        Authorization: "{authorization}",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: JSON.stringify({
        messages: [
          {
            from: "HOTSHOTS",
            destinations: [
              { to: "4421376087", messageId: "MESSAGE-ID-123-xyz" },
            ],
            text:
              "Artık Ulusal Dil Tanımlayıcısı ile Türkçe karakterli smslerinizi rahatlıkla iletebilirsiniz.",
            flash: false,
            language: { languageCode: "TR" },
            intermediateReport: true,
            notifyUrl: "mpmdpj.api.infobip.com/sms/advanced",
            notifyContentType: "application/json",
            callbackData: "DLR callback data",
            validityPeriod: 720,
          },
        ],
        bulkId: "BULK-ID-123-xyz",
        tracking: { track: "SMS", type: "MY_CAMPAIGN" },
      }),
    };

    $.ajax(settings).done(function (response) {
      console.log("Sms response ", response);
    });
  }

  async signin() {
    this.loading = await true;
    await this._authService
      .login(this.model.email, this.model.password)
      .subscribe(
        (data) => {
          // var flag;
          //  ;
          // flag = this._commonService.CheckHasRight('VIEW', 'ANALYTICS_DETAILS');
          var analyticsFlag;
          var tripDocumentFlag;
          var UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
          this._appService.GetByThreeId("OrdersByVehicle", "opa_checkUserRightForLaneUpdate", UserId, 'TRIPDOCUMENTPRINT_DETAILS', 'VIEW').subscribe((response) => {
            if (response[0].isReights == 'YES') {
              // this._router.navigate(['tripDocumentPrint']);

              //add vithujan 29-08-2022
              if (response[0].UserRoleName == 'Customer') {
                if (this.hostUrl == 'https://nol.ifreightbox.net/' || this.hostUrl == 'http://localhost:60144/') {
                  this._appService.GetByTwoId("User", "checkUserReights", UserId, 'RATE_CHECK').subscribe((response) => {
                    if (response[0].isReights == 'TRUE') {
                      this._router.navigateByUrl("/rate-check");
                    } else {
                      this._router.navigateByUrl("/tripDocumentPrint");
                    }
                  });
                } else {
                  this._router.navigateByUrl("/tripDocumentPrint");
                }
              }
              else {
                this._router.navigate([this.returnUrl]);
              }
              //end

            } else {
              let Userid = UserId;
              this._appService.GetById("OrdersByVehicle", "checkTransporter", Userid).subscribe((response) => {
                if (response[0].isTransporter == true || response[0].isCustomer == true) {
                  this._appService.GetByTwoId("Signup", "checkUserBeforeLoginMainPage", this.model.email, response[0].isTransporter == true ? "trans" : "cust").subscribe((res) => {
                    if (res[0].isAuth === 0) {
                      this.loading = false;
                      // this._alertService.error("User not authorize");
                      this.showAlert("alertSignin");
                      this._alertService.error("User not authorize to login");
                      // this.toastr.error("User not authorize", "Error");
                      this._authService.logout();
                    } else {
                      //add vithujan 29-08-2022
                      if (response[0].isCustomer == true) {
                        this._appService.GetByTwoId("User", "checkUserReights", UserId, 'RATE_CHECK').subscribe((response) => {
                          if (response[0].isReights == 'TRUE') {
                            this._router.navigateByUrl("/rate-check");
                          } else {
                            this._router.navigate([this.returnUrl]);
                          }
                        });
                      } else {
                        this._router.navigate([this.returnUrl]);
                      }
                      //end
                    }
                  });
                } else {
                  if (!this.isBestUrl)
                    this._router.navigate([this.returnUrl]);
                  else
                    this._router.navigateByUrl("/VehicleTracking");
                }
              },
                (err) => {
                  this.toastr.error(err._body.replace(/"/g, ""), "error");
                });
            }
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "Error");
              Helpers.setLoading(false);
            });
          this._appService
            .Get("FuelPrice", "CheckFuelFlag")
            .subscribe((Response) => {
              this.flag = Response;
            });
        },
        (error) => {
          const InvalidUsernameorPassword = this.translate.instant("ALERTMESSAGES.InvalidUsernameorPassword")
          console.log('error._body.replace(/"/g, "")', error);
          if (error._body.replace(/"/g, "") == '{error:Please change password.}') {
            this.showAlert("alertSignin");
            this._alertService.error('Please change password.');
          } else {
            this.showAlert("alertSignin");
            this._alertService.error(InvalidUsernameorPassword);
          }
          this.loading = false;
        }
      );
  }

  signup() {
    this.loading = true;
    this._userService.create(this.model).subscribe(
      (data) => {
        this.showAlert("alertSignin");
        this._alertService.success(
          "Thank you. To complete your registration please check your email.",
          true
        );
        this.loading = false;
        LoginCustom.displaySignInForm();
        this.model = {};
      },
      (error) => {
        this.showAlert("alertSignup");
        this._alertService.error(error);
        this.loading = false;
      }
    );
  }

  //added by vithujan 30-08-2022
  forgotPass() {
    var apiUrl = environment.apiUrl + "api/User/GetForgotPasswordLogByEmail?Id=" + this.model.email;

    this.http.get(apiUrl).subscribe(
      (response) => {
        var data = response;
        var count = Object.keys(data);

        if (count.length != 0) {
          var minutes = data[0].MinuteDiff;
          this.timeLeft = 300 - minutes;

          if (minutes < 300) {
            this.isShowTimer = true;
            document.getElementById("m_login_forget_password_submit").classList.add('disabled');
            this.startTimer();
            this.toaster.error(this.translate.instant("ResetPassword.PassLinkDisable"));
            return;
          } else {
            this.isShowTimer = false;
            document.getElementById("m_login_forget_password_submit").classList.remove('disabled');
            this.SendPasswordResetMail();
          }
        } else {
          this.isShowTimer = false;
          document.getElementById("m_login_forget_password_submit").classList.remove('disabled');
          this.SendPasswordResetMail();
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  ShowTimer() {
    var apiUrl = environment.apiUrl + "api/User/GetForgotPasswordLogByEmail?Id=" + this.model.email;

    this.http.get(apiUrl).subscribe(
      (response) => {
        var data = response;
        var count = Object.keys(data);

        if (count.length != 0) {
          var minutes = data[0].MinuteDiff;
          this.timeLeft = 300 - minutes;

          if (minutes < 300) {
            this.isShowTimer = true;
            document.getElementById("m_login_forget_password_submit").classList.add('disabled');
            this.startTimer();
            return;
          } else {
            this.isShowTimer = false;
            document.getElementById("m_login_forget_password_submit").classList.remove('disabled');
          }
        } else {
          this.isShowTimer = false;
          document.getElementById("m_login_forget_password_submit").classList.remove('disabled');
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  SendPasswordResetMail() {
    this.loading = true;
    this._userService.forgotPassword(this.model.email).subscribe(

      (data) => {
        const Passwordrecovery = this.translate.instant("ALERTMESSAGES.Passwordrecovery")

        this.loading = false;
        this.toaster.info(Passwordrecovery, "Success");
        this.ShowTimer();
        this.showAlert("alertSignin");

        LoginCustom.displaySignInForm();
        this.model = {};
        console.log('error', data);
      },
      (error) => {
        this.showAlert("alertForgotPass");
        //added by vithujan 02-11-2022
        const Passwordrecovery = this.translate.instant("ALERTMESSAGES.Passwordrecovery");
        this.toaster.info(Passwordrecovery, "Success");
        //end

        // this._alertService.error(error._body.replace(/"/g, " "));
        this.loading = false;
      }
    );
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 0;
        this.isShowTimer = false;
        document.getElementById("m_login_forget_password_submit").classList.remove('disabled');
      }
      this.display = this.transform(this.timeLeft)
    }, 1000)
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return minutes + ':' + (value - minutes * 60);
  }
  //end

  showAlert(target) {
    // this[target].clear();
    let factory = this.cfr.resolveComponentFactory(AlertComponent);
    let ref = this[target].createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  ShowForgottedPassword() { }

  GetRights() {
    let user = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
    var Roles = $.parseJSON(user);

    this._appService.GetById("RoleRights", "GetRightsByRole", Roles).subscribe(
      (response) => {
        //alert(JSON.stringify(response));
        localStorage.setItem("rights_assigned", JSON.stringify(response));
        this.ReloadPage();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  ReloadPage() {
    window.location.reload();
  }

  // add kevin 22/06/2021
  getWhiteLable() {
    this._userService.getByIdWhiteLable('WhiteLabel').subscribe((data) => {
      this.WhiteLabel = data;
    },
      (error) => {
        this.showAlert(error);
        this.loading = false;
      });
  }
  // end
}
